import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showFooterBanner: false,
  showSelectTrialPopUp: false,
  isTrialEnded: false,
  daysLeft: 0,

  trialEndDate: '',
  subscriptionCancelled: false,
  trialDuration: 0,
  isSuspended: false,
  dayOfTrial: 0,
  inTrial: false,

  isFetched: false,
};

const trialPeriodSlice = createSlice({
  name: 'trialPeriod',
  initialState,
  reducers: {
    /* eslint-disable no-param-reassign */
    setTrialPeriodData(state, action) {
      state.showFooterBanner = action.payload.showFooterBanner;
      state.showSelectTrialPopUp = action.payload.showSelectTrialPopUp;
      state.isTrialEnded = action.payload.isTrialEnded;
      state.daysLeft = action.payload.daysLeft;

      state.trialEndDate = action.payload.trialEndDate;
      state.subscriptionCancelled = action.payload.subscriptionCancelled;
      state.trialDuration = action.payload.trialDuration;
      state.isSuspended = action.payload.suspended;
      state.dayOfTrial = action.payload.dayOfTrial;
      state.inTrial = action.payload.inTrial;
      state.isFetched = true;
    },
    closPopUp(state) {
      state.showSelectTrialPopUp = false;
    },
    openSelectTrialFlowPopup(state) {
      state.showSelectTrialPopUp = true;
    },
  },
});

export default trialPeriodSlice.reducer;

export const { setTrialPeriodData, closPopUp, openSelectTrialFlowPopup } =
  trialPeriodSlice.actions;
